<template>
    <div style="width: 95%;">
      <template v-if="loading">
        <Loader :delay="0"></Loader>
      </template>
      <template v-else>
      <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="IRC En Servicio">
                <b-form-select  v-model="info.irc_en_servicio" :options="irc_servicio_options" class="mb-3" text-field="tipo" value-field="tipo" :disabled="!hasPermision('E')"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Uso IRC">
                <b-form-select v-model="info.uso_irc" :options="irc_uso_options" class="mb-3" text-field="tipo" value-field="tipo" :disabled="!hasPermision('E')"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Ubicación sala caldera">
                <b-form-select v-model="info.ubicacion_sala_caldera" :options="ubicacion_options" class="mb-3" text-field="ubicacion_sala_caldera" value-field="ubicacion_sala_caldera" :disabled="!hasPermision('E')"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Régimen vivienda finca">
                <b-form-select v-model="info.regimen_vivienda_finca" :options="regimen_options" class="mb-3" text-field="tipo" value-field="tipo" :disabled="!hasPermision('E')"/>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Columna anillo">
                <b-form-select v-model="info.columna_anillo" :options="columna_options" class="mb-3" text-field="columna_anillo" value-field="columna_anillo" :disabled="!hasPermision('E')"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Tubular">
                <b-form-select v-model="info.monotubular_bitubular" :options="tubular_options" class="mb-3" :disabled="!hasPermision('E')"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Sala descentralizada">
                <b-form-select v-model="info.sala_descentralizada" :options="sala_options" class="mb-3" text-field="tipo" value-field="tipo" :disabled="!hasPermision('E')"/>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Año instalación caldera">
                <b-form-input v-model="info.antiguedad_caldera" :disabled="!hasPermision('E')"></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Num. tanques">
                <b-form-input v-model="info.nro_tanques" :disabled="!hasPermision('E')"></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Capacidad depósito">
                <b-form-input v-model="info.capacidad_deposito" :disabled="!hasPermision('E')"></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Mantenedor caldera">
                <b-form-input v-model="info.mantenedor_caldera" :disabled="!hasPermision('E')"></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Suministrador combustible caldera">
                <b-form-input v-model="info.suministrador_combustible_caldera" :disabled="!hasPermision('E')"></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: right;" v-if="hasPermision('E')">
                <b-button @click="cancel">Cancelar</b-button>
                <b-button @click="save">Guardar</b-button>
            </b-col>
        </b-row>
      </template>
    </div>
</template>

<script>
import Loader from '@/components/Layout/Loader.vue';

export default {
  name: 'InfoAdicional',
  props: ['feature', 'type', 'permisos'],
  components: {
    Loader
  },
  data () {
    return {
      info: null,
      loading: true,
      irc_servicio_options: [],
      irc_uso_options: [],
      ubicacion_options: [],
      regimen_options: [],
      columna_options: [],
      sala_options: [],
      tubular_options: ['', 'MONOTUBULAR', 'BITUBULAR']
    };
  },
  mounted: function () {
    this.loading = true;
    this.$http.get('caldera_extendida/' + this.feature.properties.id + '/').then(result => {
      this.info = result.data;

      this.initOptions();
    });
  },
  methods: {
    initOptions: function () {
      Promise.all([
        this.$http.get('irc_en_servicio/', {params: {not_paginated: true}}),
        this.$http.get('irc_uso/', {params: {not_paginated: true}}),
        this.$http.get('ubicacion_sala_caldera/', {params: {not_paginated: true}}),
        this.$http.get('regimen_vivienda/', {params: {not_paginated: true}}),
        this.$http.get('columna_anillo/', {params: {not_paginated: true}}),
        this.$http.get('sala_descentralizada/', {params: {not_paginated: true}})
      ]).then(results => {
        this.irc_servicio_options = [{id: null, tipo: ''}].concat(results[0].data);
        this.irc_uso_options = [{id: null, tipo: ''}].concat(results[1].data);
        this.ubicacion_options = [{id: null, ubicacion_sala_caldera: ''}].concat(results[2].data);
        this.regimen_options = [{id: null, tipo: ''}].concat(results[3].data);
        this.columna_options = [{id: null, columna_anillo: ''}].concat(results[4].data);
        this.sala_options = [{id: null, tipo: ''}].concat(results[5].data);

        this.loading = false;
      });
    },
    hasPermision: function (p) {
      var rol = '';
      if (this.type === 'caldera') {
        rol = 'CALDERA CENTRALIZADA';
      } else {
        rol = 'COMERCIAL';
      }
      return this.permisos[rol][p];
    },
    save: function () {
      this.loading = true;
      this.$http.put('caldera_extendida/' + this.feature.properties.id + '/', this.info).then(result => {
        this.loading = false;
      });
    },
    cancel: function () {
      this.loading = true;
      this.$http.get('caldera_extendida/' + this.feature.properties.id + '/').then(result => {
        this.info = result.data;
        this.loading = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/info_adicional.vue